import { useState } from 'react'
import { router } from '@inertiajs/react'
import { useFlashToast } from '../../hooks/useFlashToast'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faCheck, faCheckDouble, faInbox } from '@fortawesome/free-solid-svg-icons'
import UserSidebar from '../../components/user/Sidebar'
import UserTopbar from '../../components/user/Topbar'
import AdminSidebar from '../../components/admin/Sidebar'
import AdminTopbar from '../../components/admin/Topbar'
import SuperadminSidebar from '../../components/superadmin/Sidebar'
import SuperadminTopbar from '../../components/superadmin/Topbar'

const PORTAL_SHELL = {
  user: { Sidebar: UserSidebar, Topbar: UserTopbar, shell: 'bg-gray-50 text-gray-900' },
  admin: { Sidebar: AdminSidebar, Topbar: AdminTopbar, shell: 'bg-gray-50 text-gray-900' },
  superadmin: { Sidebar: SuperadminSidebar, Topbar: SuperadminTopbar, shell: 'bg-gray-950 text-gray-100' },
}

const KIND_STYLE = {
  report: 'bg-blue-100 text-blue-700',
  identity: 'bg-amber-100 text-amber-700',
  system: 'bg-gray-100 text-gray-600',
  info: 'bg-emerald-100 text-emerald-700',
}

export default function NotificationsIndex({ current_user, portal = 'user', notifications = [], notifications_path }) {
  useFlashToast()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { Sidebar, Topbar, shell } = PORTAL_SHELL[portal] || PORTAL_SHELL.user
  const dark = portal === 'superadmin'

  const markRead = (id) => router.patch(`${notifications_path}/${id}/mark_read`)
  const markAllRead = () => router.patch(`${notifications_path}/mark_all_read`)

  return (
    <div className={`flex h-screen font-sans overflow-hidden ${shell}`}>
      <Sidebar current_user={current_user} open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <Topbar current_user={current_user} onMenuToggle={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto p-4 lg:p-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
            <div>
              <h1 className={`text-xl font-bold ${dark ? 'text-white' : 'text-gray-900'}`}>Notifikasi</h1>
              <p className={`text-sm mt-0.5 ${dark ? 'text-gray-500' : 'text-gray-500'}`}>Pembaruan laporan dan aktivitas sistem</p>
            </div>
            {notifications.some(n => !n.read) && (
              <button
                onClick={markAllRead}
                className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-colors ${dark ? 'bg-gray-800 border border-gray-700 text-gray-300 hover:bg-gray-700' : 'bg-white border border-gray-200 text-gray-700 hover:bg-gray-50'}`}
              >
                <FontAwesomeIcon icon={faCheckDouble} className="w-3.5 h-3.5" />
                Tandai semua dibaca
              </button>
            )}
          </div>

          {notifications.length === 0 ? (
            <div className={`rounded-xl border p-12 text-center ${dark ? 'bg-gray-900 border-gray-800' : 'bg-white border-gray-200'}`}>
              <FontAwesomeIcon icon={faInbox} className={`w-10 h-10 mb-3 ${dark ? 'text-gray-600' : 'text-gray-300'}`} />
              <p className={dark ? 'text-gray-400' : 'text-gray-500'}>Belum ada notifikasi.</p>
            </div>
          ) : (
            <ul className="space-y-2 max-w-3xl">
              {notifications.map(n => (
                <li
                  key={n.id}
                  className={`rounded-xl border p-4 flex gap-4 ${dark ? 'bg-gray-900 border-gray-800' : 'bg-white border-gray-200'} ${!n.read ? (dark ? 'ring-1 ring-indigo-600/40' : 'ring-1 ring-blue-200') : ''}`}
                >
                  <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${dark ? 'bg-gray-800' : 'bg-blue-50'}`}>
                    <FontAwesomeIcon icon={faBell} className={`w-4 h-4 ${dark ? 'text-indigo-400' : 'text-blue-600'}`} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2 flex-wrap">
                      <p className={`text-sm font-semibold ${dark ? 'text-gray-100' : 'text-gray-900'}`}>{n.title}</p>
                      <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full uppercase ${KIND_STYLE[n.kind] || KIND_STYLE.info}`}>{n.kind}</span>
                    </div>
                    {n.body && <p className={`text-sm mt-1 ${dark ? 'text-gray-400' : 'text-gray-600'}`}>{n.body}</p>}
                    <p className={`text-[11px] mt-2 ${dark ? 'text-gray-600' : 'text-gray-400'}`}>{n.created_at}</p>
                    <div className="flex flex-wrap gap-2 mt-3">
                      {n.link && (
                        <a href={n.link} className={`text-xs font-semibold ${dark ? 'text-indigo-400 hover:text-indigo-300' : 'text-blue-600 hover:text-blue-700'}`}>
                          Lihat detail →
                        </a>
                      )}
                      {!n.read && (
                        <button onClick={() => markRead(n.id)} className={`text-xs font-medium inline-flex items-center gap-1 ${dark ? 'text-gray-500 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700'}`}>
                          <FontAwesomeIcon icon={faCheck} className="w-3 h-3" />
                          Tandai dibaca
                        </button>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </main>
      </div>
    </div>
  )
}
